var render = function render(){var _vm=this,_c=_vm._self._c;return _c('module-template',{attrs:{"name":_vm.name,"info":"Im Gegensatz zu den anderen Zugriffseinstellungen gelten die hier gemachten Änderungen für alle Gliederungen, in denen der Mitarbeitende angemeldet ist."},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }